export interface IState {
	images: Image[]
}
export interface Image {
	uri: String,
	alt: String,
	description: String
}

const deafultState: IState = {
	images: []
}

export default deafultState;
